const selectors = {
    content: '[data-content]',
    contentContainer: '[data-content-container]',
    scrollTo: '[data-scroll-to]',
    scrollToEl: (id) => `[data-scroll-id="${id}"]`,
    button: '[data-toggle-button]',
    wrap: '[data-toggle-wrap]',
    body: '[data-toggle-body]',
    open: '[data-toggle-open]',
    close: '[data-toggle-close]'
};
renderContentListTable();

function renderContentListTable() {
    const content = document.querySelector(selectors.content);

    if (!content) return;
    const contentContainer = content.querySelector(selectors.content);
    const titles = Array.from(content.children).filter(el => el.tagName === 'H2' || el.tagName === 'H3');
    if (!titles) return;

    const contentListBody = document.createElement("div"),
        contentList = document.createElement("div");
    const contentListWrapper = document.createElement("div");
    contentList.append(contentListWrapper);
    contentListWrapper.classList.add('table-of-contents__wrapper');
    contentListBody.setAttribute('data-toggle-body', '');
    contentListBody.classList.add('table-of-contents__body');
    contentListBody.classList.add('active');
    contentList.classList.add('table-of-contents');
    contentList.classList.add('active');
    contentList.setAttribute('data-toggle-wrap', '');
    contentList.setAttribute('data-content-list', '');
    const contentListHeader = document.createElement("header");
    contentListHeader.setAttribute('data-content-header', '');
    contentListHeader.classList.add('table-of-contents__header')
    contentListWrapper.append(contentListHeader);
    contentListHeader.innerHTML = `<h2>Table of contents</h2>
        <div id="sr-status" role="status" aria-live="polite" aria-atomic="true" class="sr-only">Hide</div>
        <button data-toggle-hide="Hide" data-toggle-open="Open" data-toggle-button class="button button--transparent button--small active" >
            <span>Hide</span>    
            <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="https://www.w3.org/2000/svg">
                <path d="M9.70292 6.99976L5.5 2.67137L1.29708 6.99976L0 5.66395L5.5 -0.000244141L11 5.66395L9.70292 6.99976Z" fill="#C19C64"/>
            </svg>
            
        </button>`;

    let firstIndex = titles.findIndex(el => el.tagName == 'H2');
    if (firstIndex > -1) {
        var html = '<ul class="table-of-contents__list">';
        for (var i = firstIndex + 1; i <= titles.length - 1; i++) {
            if (titles[i].tagName == 'H2') {
                titles[firstIndex].id = "heading-" + firstIndex;
                let temporary = titles.slice(firstIndex, i);
                html += `<li class="table-of-contents__list-item"><a href="#heading-${firstIndex}">${titles[firstIndex].innerText}</a></li>`
                firstIndex = i;
            }
            if (i === (titles.length - 1) && firstIndex > -1) {
                titles[firstIndex].id = "heading-" + firstIndex;
                const li = document.createElement("li");
                let temporary = titles.slice(firstIndex, titles.length)
                html += `<li class="table-of-contents__list-item"><a href="#heading-${firstIndex}">${titles[firstIndex].innerText}</a></li>`
            }

        }
        html += '</ul>';
        contentListBody.innerHTML = html;
        contentListWrapper.appendChild(contentListBody)

        contentContainer ? contentContainer.append(contentList) : content.prepend(contentList)
    }
    document.addEventListener('click', event => {
        const {target} = event;

        if (target.matches(selectors.scrollTo)) {
            event.preventDefault();
            const id = target.getAttribute('data-scroll-to');
            const scrollToEl = document.querySelector(selectors.scrollToEl(id));
            const offset = window.innerWidth < 1450 ? contentListHeader.offsetHeight + 250 : 0;
            window.scrollTo({
                top: scrollToEl.offsetTop - offset,
                behavior: 'smooth'
            });
        }
    })
    var lastScrollTop = 0,
        scrollDirection;
}

function renderInnerElement(temporary, i) {
    if (!temporary.length) return ``;
    const subtitles = temporary.filter(el => el.tagName === 'H3');
    if (!subtitles.length) return ``;
    return `<div class="table-of-contents__dropdown"><ul> ${subtitles.map((el, index) => {
        el.setAttribute('data-scroll-id', `${i}-${index}`);
        return `<li><a data-scroll-to="${i}-${index}" href="#">${el.innerText}</a></li>`
    })}</ul></div>`;
}

const toggleElement = (element) => {
    const open = element.getAttribute('data-toggle-open');
    const close = element.getAttribute('data-toggle-hide');
    const wrap = element.closest(selectors.wrap);
    const body = wrap ? wrap.querySelector(selectors.body) : undefined;
    const text = element.querySelector('span');
    const sR = document.getElementById('sr-status');

    element.classList.toggle('active');
    wrap ? wrap.classList.toggle('active') : '';
    body ? body.classList.toggle('active') : '';
    if (!open || !close || !text) return;
    element.classList.contains('active') ? text.innerText = close : text.innerText = open;
    element.classList.contains('active') ? sR.innerText = close : sR.innerText = open;

};

document.addEventListener('click', (event) => {
    const target = event.target;
    if (target.matches(`${selectors.button}, ${selectors.button} *`)) {
        event.preventDefault();
        const element = target.matches(selectors.button) ? target : target.closest(selectors.button);
        toggleElement(element);
    }
});


